// salesFilters.js

import React from "react";
import SearchIcon from "../assets/search-icon.png";
import "../styles/salesFilters.css";

const SalesFilters = ({
  label,
  type = "text",
  name,
  readOnly = false,
  withButton = false,
  onButtonClick,
  value = "",
  hiddenValue = "",
  onChange,
  placeholder = "",
  required = false
}) => {

  return (
    <label className="filter-field">

      <span className="filter-label">
        {label}
        {required && (
          <span className="required-asterisk"> *</span>
        )}
        :
      </span>

      {withButton ? (

        <div className="input-button">

          <input
            type={type}
            name={name}
            autoComplete="off"
            readOnly={readOnly}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
          />

          <input
            type="hidden"
            name={name + "_id"}
            value={hiddenValue}
          />

          <button
            type="button"
            className="search-button"
            onClick={onButtonClick}
          >
            <img src={SearchIcon} alt="Search" />
          </button>

        </div>

      ) : (

        <input
          type={type}
          name={name}
          autoComplete="off"
          readOnly={readOnly}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        />

      )}

    </label>
  );
};

export default SalesFilters;